/**
 * Shared validation utility functions
 * Extracted from StoreDetailsModal.jsx and ValidationResultsViewer.jsx
 */

export const getValidationStatusIcon = (status, score) => {
    if (status === 'error' || score < 50) {
        return 'error';
    } else if (status === 'warning' || score < 80) {
        return 'warning';
    } else {
        return 'success';
    }
};

export const getValidationStatusColor = (status, score) => {
    if (status === 'error' || score < 50) {
        return 'bg-red-50 border-red-200 text-red-700';
    } else if (status === 'warning' || score < 80) {
        return 'bg-amber-50 border-amber-200 text-amber-700';
    } else {
        return 'bg-emerald-50 border-emerald-200 text-emerald-700';
    }
};

export const calculateOverallScore = (validations) => {
    if (!validations) return 0;

    const scores = Object.values(validations)
        .filter(v => v && typeof v.score === 'number')
        .map(v => v.score);

    if (scores.length === 0) return 0;

    return Math.round(scores.reduce((sum, score) => sum + score, 0) / scores.length);
};
